import type { DeviceSettings } from "@tandemdiabetes/sugarmate-api-react-client"
import {
  DayStat,
  GraphDotColor,
  Theme,
  ThemeAppearance,
} from "@tandemdiabetes/sugarmate-api-react-client"

export const defaultDeviceSettings: DeviceSettings = Object.freeze({
  id: "",
  account_id: -1,
  device_id: -1,
  follow_id: "",
  following_account_id: -1,
  is_self: true,
  graph_icon_info: true,
  graph_icon_scale: 1,
  feed_buttons: [],
  nightstand_mode: false,
  nightstand_graph: false,
  hide_notes_history: false,
  show_delta: true,
  chart_bottom: 0,
  chart_top: 400,
  dot_color: GraphDotColor.Default,
  theme: Theme.Sugarmate,
  day_stat: DayStat.None,
  theme_appearance: ThemeAppearance.OS,
  insights: [],
  created_at: "",
  updated_at: "",
  deleted_at: null,
})
